
function About() {
    return(
        <div>
            <br/><br/>
            <h2><b>Who We Are</b></h2>
            <h4 className='page-text hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                Martin Mechanical is committed to delivering reliable, high-quality plumbing services for commercial and residential projects. 
                Our mission is to provide durable plumbing systems installed with precision, efficiency, and professionalism.
                <br/><br/>
                We focus on quality workmanship, safety, and customer satifaction on every project.
                <br/><br/>
            </h4>
            <h4 className='page-text visible-xs visible-sm'>
                <br/>
                Martin Mechanical is committed to delivering reliable, high-quality plumbing services for commercial and residential projects. 
                Our mission is to provide durable plumbing systems installed with precision, efficiency, and professionalism.
                <br/><br/>
                We focus on quality workmanship, safety, and customer satifaction on every project.
                {/* Martin Mechanical is a locally owned and operated plumbing company 
                providing high-quality residential and commercial plumbing services. 
                We pride ourselves on reliability, transparent pricing, and professional workmanship. */}
                <br/><br/>
            </h4>
            <h2><b>Our Mission</b></h2>
            <h4 className='page-text hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                To Provide dependable services that combine skilled craftmanship, efficient solutions, and long-lasting results.
                <br/><br/>
            </h4>
            <h4 className='page-text visible-xs visible-sm'>
                <br/>
                To Provide dependable services that combine skilled craftmanship, efficient solutions, and long-lasting results.
                <br/><br/>
            </h4>
            <h2><b>Why Choose Us</b></h2>
            <h4 className='page-text hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                <ul className="about-ul">
                    <li>&#x2714;&nbsp;Licensed & insured technicians</li><br/>
                    <li>&#x2714;&nbsp;Same-day and emergency service</li><br/>
                    <li>&#x2714;&nbsp;Upfront pricing</li><br/>
                    <li>&#x2714;&nbsp;Quality parts & workmanship</li><br/>
                    <li>&#x2714;&nbsp;Friendly, respectful service</li><br/>
                </ul>
            <br/><br/>
            </h4>
            <h4 className='page-text visible-xs visible-sm'>
                <br/>
                <ul className="about-ul" style={{textAlign: "left"}}>
                    <li>&#x2714;&nbsp;Licensed & insured technicians</li><br/>
                    <li>&#x2714;&nbsp;Same-day and emergency service</li><br/>
                    <li>&#x2714;&nbsp;Upfront pricing</li><br/>
                    <li>&#x2714;&nbsp;Quality parts & workmanship</li><br/>
                    <li>&#x2714;&nbsp;Friendly, respectful service</li><br/>
                </ul>
                <br/><br/>
            </h4>
        </div>
    )
}
export default About;